var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[(_vm.showAltitude)?_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"oax-api-elpro"}}):_c('div',{style:('min-height:' + _vm.height + 'px'),attrs:{"id":"map_canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }